// extracted by mini-css-extract-plugin
export default {"divider":"AttachmentAddStep_divider__DkNuP","menu":"AttachmentAddStep_menu__zr5Ni","menuItem":"AttachmentAddStep_menuItem__Olmhh","tip":"AttachmentAddStep_tip__a-MAr"};